var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Suspend',{ref:"suspendRef",on:{"close":_vm.close}})
}
var staticRenderFns = []

export { render, staticRenderFns }